import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import SbuForm from '../components/forms/SbuForm';
import SbuTable from '../components/SbuTable';

const SbuEditModel = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const navigate = useNavigate();
     const location = useLocation();
     const { id } = useParams();

     const [sbuData, setSbuData] = useState(null);
     const [loading, setLoading] = useState(false);

     const showModal = location.pathname.startsWith('/sbu/edit');

     const handleCloseModal = () => {
          navigate('/sbu');
     };

     useEffect(() => {
          if (id && showModal) {
               setLoading(true);
               fetch(`${baseUrl}/getSbuById/${id}`)
                    .then(res => res.json())
                    .then(data => {
                         if (data.status) {
                              setSbuData(data.data);
                         } else {
                              setSbuData(null);
                         }
                         setLoading(false);
                    })
                    .catch(err => {
                         setLoading(false);
                    });
          }
     }, [id, showModal, baseUrl]);

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>SBU Master</h2>
               </div>
               <SbuTable />
               <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
                    <Modal.Header closeButton>
                         <Modal.Title>Edit SBU</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         {loading ? (
                              <div className="text-center">
                                   <Spinner animation="border" /> Loading...
                              </div>
                         ) : sbuData ? (
                              <SbuForm sbuId={id} initialData={sbuData} />
                         ) : (
                              <p className="text-center">No data found for this SBU.</p>
                         )}
                    </Modal.Body>
               </Modal>
          </div>
     );
};

export default SbuEditModel;